type LoaderFunction = () => void;

let showLoader: LoaderFunction = () => {};
let hideLoader: LoaderFunction = () => {};

/**
 * Sets the loader functions dynamically.
 * @param show - Function to show the loader
 * @param hide - Function to hide the loader
 */
export const setLoaderFunctions = (show: LoaderFunction, hide: LoaderFunction): void => {
  showLoader = show;
  hideLoader = hide;
};

/**
 * Retrieves the current loader functions.
 * @returns An object containing the `showLoader` and `hideLoader` functions.
 */
export const getLoaderFunctions = (): { showLoader: LoaderFunction; hideLoader: LoaderFunction } => ({
  showLoader,
  hideLoader,
});
